import { AxiosInstance } from 'axios';

import { HEALTH_MONITOR_BASE_URL } from '../util/environment';

import { createAxiosInstance } from './create-axios-instance';

export const axiosInstanceHealthMonitor: AxiosInstance =
  createAxiosInstance({
    baseURL: HEALTH_MONITOR_BASE_URL.endsWith('/')
      ? HEALTH_MONITOR_BASE_URL
      : HEALTH_MONITOR_BASE_URL.concat('/'),
  });

export default axiosInstanceHealthMonitor;